import { useEffect, useState } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Header } from "@/components/Header";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { CheckCircle2, Loader2, Crown, XCircle } from "lucide-react";

export default function PaymentSuccess() {
  const location = useLocation();
  const nav = useNavigate();
  const { refresh } = useAuth();
  const [status, setStatus] = useState("checking");

  useEffect(() => {
    const sid = new URLSearchParams(location.search).get("session_id");
    if (!sid) { setStatus("error"); return; }
    let tries = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (data.payment_status === "paid" || data.status === "completed") {
          setStatus("ok");
          refresh();
          return;
        }
      } catch (e) {}
      if (tries++ < 10) setTimeout(poll, 2000);
      else setStatus("pending");
    };
    poll();
  }, [location.search]);

  return (
    <div className="App min-h-screen bg-background">
      <Header />
      <div className="mx-auto flex max-w-lg flex-col items-center px-4 py-24 text-center sm:px-6">
        {status === "checking" && (
          <>
            <Loader2 className="h-10 w-10 animate-spin text-primary" />
            <p className="mt-4 text-muted-foreground" data-testid="payment-checking">Validation de votre abonnement...</p>
          </>
        )}
        {status === "ok" && (
          <motion.div initial={{ scale: 0.9, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} data-testid="payment-success">
            <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-primary/10 text-primary">
              <CheckCircle2 className="h-9 w-9" />
            </div>
            <h1 className="mt-5 font-display text-3xl font-800 text-secondary">Bienvenue chez Premium !</h1>
            <p className="mt-2 flex items-center justify-center gap-1 text-muted-foreground">
              <Crown className="h-4 w-4 text-accent" /> Votre essai gratuit de 7 jours a démarré.
            </p>
            <Button onClick={() => nav("/comparateur")} className="mt-6 rounded-full" data-testid="success-go-app">Aller au comparateur</Button>
          </motion.div>
        )}
        {status === "pending" && (
          <>
            <Loader2 className="h-10 w-10 animate-spin text-accent" />
            <p className="mt-4 text-muted-foreground" data-testid="payment-pending">Paiement en cours de traitement. Cela peut prendre quelques instants.</p>
            <Link to="/premium"><Button variant="outline" className="mt-4 rounded-full">Retour</Button></Link>
          </>
        )}
        {status === "error" && (
          <>
            <XCircle className="h-10 w-10 text-destructive" />
            <p className="mt-4 text-muted-foreground" data-testid="payment-error">Session de paiement introuvable.</p>
            <Link to="/premium"><Button variant="outline" className="mt-4 rounded-full">Retour à Premium</Button></Link>
          </>
        )}
      </div>
    </div>
  );
}
